var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-btn-o-auth",attrs:{"title":`login with ${_vm.provider}`},on:{"click":function($event){$event.preventDefault();return _vm.oAuthLogin()}}},[_c('v-img',{attrs:{"src":require(`@/assets/svg/${_vm.provider}.svg`),"alt":`login with ${_vm.provider}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }